export default "__VITE_ASSET__Cbm4VFFB__"